import { categories } from '@/mocks/categories';
import { homeContent } from '@/mocks/content';

export default function AllCategories() {
  return (
    <section className="py-16 md:py-24 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full border border-accent-300 text-xs font-semibold text-accent-700 uppercase tracking-wider mb-4">
            {homeContent.sectionAllCategoriesTag}
          </span>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 mb-3">
            {homeContent.sectionAllCategoriesTitle}
          </h2>
          <p className="text-base md:text-lg text-foreground-500 max-w-xl mx-auto">
            {homeContent.sectionAllCategoriesSubtitle}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => (
            <a
              key={cat.id}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col rounded-2xl bg-background-50 hover:bg-accent-50 transition-colors cursor-pointer overflow-hidden"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={cat.image}
                  alt={cat.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 md:p-5 flex-1 flex flex-col">
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-950 mb-1">
                  {cat.name}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed mb-3 flex-1">
                  {cat.description}
                </p>
                <span className="inline-flex items-center gap-1 text-xs font-semibold text-accent-600 group-hover:text-accent-700 whitespace-nowrap">
                  Перейти
                  <span className="w-3 h-3 flex items-center justify-center">
                    <i className="ri-arrow-right-up-line text-xs"></i>
                  </span>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}